module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"gave_mileage_message":"<b>已發放 {mileage_amount}｜</b>","hidden_by_admin_message":"該評論未達發佈標準，目前暫不顯示。","hidden_by_system_message":"該評論未達發佈標準，目前暫不顯示。","hidden_by_before_confirmation_message":"內容正在審核中，通過後將會顯示。","review_edit_or_delete_info":"若需修改或刪除評論，請聯繫商城客服。"}}')
  delete Component.options._Ctor
}
